function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import get from 'lodash/get';
import validatorRules from './validatorRules.json';
const template = 'range-{type}-{range}-{thresholdLevel}';
function getNameFromTemplate(type, range, thresholdLevel) {
    return template.replace('{type}', type).replace('{range}', range).replace('{thresholdLevel}', thresholdLevel);
}
function hasValue(values, valueName) {
    const relatedValue = get(values, valueName);
    return !!relatedValue;
}
function getThreasholdValidationRule(values, type, range, currentThreshold) {
    const opposedThreshold = currentThreshold === 'highThreshold' ? 'lowThreshold' : 'highThreshold';
    const rules = [];
    if (hasValue(values, getNameFromTemplate(type, range, currentThreshold))) {
        rules.push('positive');
    }
    const relationIntoOpposedThreshold = currentThreshold === 'highThreshold' ? 'greaterThen' : 'lowerThen';
    const currentOpposedThresholdName = getNameFromTemplate(type, range, opposedThreshold);
    const relatedOpposedName = hasValue(values, currentOpposedThresholdName) ? currentOpposedThresholdName : getNameFromTemplate('Default', range, opposedThreshold);
    rules.push(`${relationIntoOpposedThreshold} ${relatedOpposedName}`);
    if (range !== 'critical') {
        const criticalHighThresholdName = getNameFromTemplate(type, 'critical', 'highThreshold');
        const relatedCricicalHighName = hasValue(values, criticalHighThresholdName) ? criticalHighThresholdName : getNameFromTemplate('Default', 'critical', 'highThreshold');
        rules.push(`lowerThen ${relatedCricicalHighName}`);
        const criticalLowThresholdName = getNameFromTemplate(type, 'critical', 'lowThreshold');
        const relatedCricicalLowName = hasValue(values, criticalLowThresholdName) ? criticalLowThresholdName : getNameFromTemplate('Default', 'critical', 'lowThreshold');
        rules.push(`greaterThen ${relatedCricicalLowName}`);
    }
    return rules.join(', ');
}
function getLowThreasholdValidationRule(values, type, range) {
    return getThreasholdValidationRule(values, type, range, 'lowThreshold');
}
function getHighThreasholdValidationRule(values, type, range) {
    return getThreasholdValidationRule(values, type, range, 'highThreshold');
}
export default function createValidationRules(values) {
    const thresholdValidatorRules = _object_spread({}, validatorRules);
    Object.keys(values).forEach((value)=>{
        if (value.includes('range')) {
            const objectValue = value.split('-');
            const type = objectValue[1];
            if (type === 'Default') return; // For Default validatorRules already defined in validatorRules.json
            const range = objectValue[2];
            const threshold = objectValue[3];
            if (threshold === 'lowThreshold') {
                const rule = getLowThreasholdValidationRule(values, type, range);
                thresholdValidatorRules[value] = rule;
            } else if (threshold === 'highThreshold') {
                const rule = getHighThreasholdValidationRule(values, type, range);
                thresholdValidatorRules[value] = rule;
            }
        }
    });
    return thresholdValidatorRules;
}
